<template>
  <div class="csp csp-word-text">
    <SubHeaderNew v-if="!titleHide" :title="title" />
    <div class="content" v-html="content" />
  </div>
</template>

<script>
// 整体实现wiki：https://cwiki.guazi.com/pages/viewpage.action?pageId=342277489
import mixin from 'cars-framework-app/src/resource/common/mixin'
import SubHeaderNew from '../components/sub-headerNew/index'
import { getCspWordText } from '@/network'
  import NativeSdk from "@/utils/nativeSdk"

export default {
  components: {
    SubHeaderNew,
  },
  mixins: [mixin],
  data() {
    const isApp = navigator.userAgent.indexOf('chesupai') > -1 || navigator.userAgent.indexOf('chesuda') > -1 || navigator.userAgent.indexOf('Guazi') > -1
    return {
      title: '',
      titleHide: this.$route.query.hideHeader == 'true' || !isApp,
      content: '',
    }
  },
  computed: {
    path() {
      return this.$route.query.path
    },
    businessType() {
      return this.$route.query.businessType
    },
    platformKey() {
      return this.$route.query.platformKey
    },
  },
  created() {
    // 队列请求
    this.$requestManage([this.getInfo]).then(() => {
      CarsBus.emit('initReady')
    })
  },
  mounted() {
      // 处理网页上的点击事件
      document.body.addEventListener('click', (event) => {
        const eventpath = event.composedPath ? event.composedPath() : event.path
        if (eventpath) {
          for (let i = 0; i < eventpath.length; i++) {
            if (eventpath[i].getAttribute && eventpath[i].getAttribute('data-type')) {
              // 获取标签上埋的属性
              const linkType = eventpath[i].getAttribute('data-type');
              const linkGoVal = eventpath[i].getAttribute('data-go-val');
              const linkDescStr = eventpath[i].getAttribute('data-desc-str');
              // 处理点击事件
              this.useLinkClickDo(linkType, linkGoVal, linkDescStr)
            }
          }
        }
      })
  },
  methods: {
    /**
     * 获取详情
     */
    async getInfo() {
      try {
        const params = {
          path: this.path,
          platformKey: this.platformKey,
          businessType: this.businessType,
        }
        const res = await getCspWordText(params);
        const response = res.data || {}
        const pageInfoX = JSON.parse(response.json) || {}
        // eslint-disable-next-line prefer-const
        let { title = '', htmlStr = '' } = pageInfoX
        // 处理标题
        this.useHtmlTitle(title);
        // 处理html内容
        this.useHtmlContent(htmlStr);
      } catch (error) {
          console.error('getInfoError---->', error)
      }
    },
    /**
     * 处理标题
     */
    useHtmlTitle(title) {
      if (title) {
          document.title = title
        }
        this.title = title
    },
    /**
     * 处理html内容
     * 1、将对应特殊字段拆解记录
      2、特殊字段拆解后更换为对应标签  H5\app下
      3、响应对应标签点击 H5、app点击
     * // contentDiv.innerHTML = htmlStr
      // const regex = new RegExp('<a href=', 'gi')
      // htmlStr = htmlStr.replace(regex, '<a data-link=')
     */
    useHtmlContent(htmlStr) {
      // 1、将对应特殊字段拆解记录$${link[http://www.baidu.com]去百度}
      const regTsZf = /\$\$\{(.+?)\}/g;
      let regResult = null;
      do {
        // 当有result时处理result[1]
        regResult = regTsZf.exec(htmlStr);
        if (regResult) {
          // 例如：link[http://www.baidu.com]去百度
          const paramsArr = regResult[1].split('[');
          // console.log('paramsArrparamsArr', paramsArr)
          // 例如：linkType为'link'
          const linkType = paramsArr[0]
          // 例如：params2Arr为['http://www.baidu.com', '去百度']；paramsArr[1]为'http://www.baidu.com]去百度'
          const params2Arr = paramsArr[1].split(']');
          // 例如：linkVal为'http://www.baidu.com'、linkDescStr为'去百度'
          const linkGoVal = params2Arr[0];
          const linkDescStr = params2Arr[1];
          // 2、特殊字段拆解后更换为对应标签  H5\app下，同时将属性写入a标签
          htmlStr = htmlStr.replace('$${'+regResult[1]+'}', '<a href="javascript:;" data-type="'+linkType +'" data-go-val="'+ linkGoVal +'" data-desc-str="'+ linkDescStr +'">'+ linkDescStr+ '</a>')
        }
      } while (regResult)
      // 赋值
      this.content = htmlStr
    },
    /**
     * 响应点击事件
     * linkType：call
     * linkGoVal：tel
     * linkDescStr：122
     */
    useLinkClickDo(linkType, linkGoVal, linkDescStr) {
      // （1）拨电话 $${call[tel]122}
      // （2）链接跳转 $${link[http://www.baidu.com]去百度}
      // （3）下载文件 $${downloadPdf[http://www.baidu.com/a.pdf]去下载}
      if ($CA.util.env.isApp) {
        if (linkType === 'call') {
          // 拨打电话
          NativeSdk.invoke('makePhoneCall', {
            number: linkDescStr,
          })
        } else if (linkType === 'link') {
          // 打开url
            NativeSdk.createWebView({
              url: linkGoVal,
              title: this.title,
              showTitleBar: !/chesupai/.test(linkGoVal),
            })
        } else if (linkType === 'downloadPdf') {
          // 打开pdf 目前wiki搜索支持车好卖和bd https://cwiki.guazi.com/pages/viewpage.action?pageId=224724984
          $CA.util.NativeAPI.invoke('preAndSharePdf', {
            pdfUrl: linkGoVal,
            pdfTitle: linkDescStr
          })
        }
      }else {
        if (linkType === 'call') {
          // tel:110
          window.location.href = linkGoVal + ':' + linkDescStr;
        } else {
          window.location.href = linkGoVal;
        }
      }
    }
  },
}
</script>

<style scoped lang="less">
@import "./index.less";
</style>
